import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { 
  FaWhatsapp, 
  FaInstagram, 
  FaFacebook, 
  FaTripadvisor 
} from 'react-icons/fa';
import './FloatingSocialIcons.css';

// --- ALTERAÇÕES AQUI: Links atualizados para o Hotel Imperial ---
const SOCIAL_ICONS = [
    { 
    id: 'whatsapp', 
    name: 'WhatsApp', 
    Icon: FaWhatsapp,
    link: 'https://wa.me/5535988171649',
    ariaLabel: 'Contate-nos via WhatsApp' 
  },
  { 
    id: 'instagram', 
    name: 'Instagram', 
    Icon: FaInstagram,
    link: 'https://www.instagram.com/alziraimperialhotel/',
    ariaLabel: 'Siga-nos no Instagram'
  },
  { 
    id: 'facebook', 
    name: 'Facebook', 
    Icon: FaFacebook,
    link: 'https://www.facebook.com/AlziraImperialhotel/',
    ariaLabel: 'Curta nossa página no Facebook'
  },
  { 
    id: 'tripadvisor', 
    name: 'Tripadvisor', 
    Icon: FaTripadvisor,
    link: 'https://www.tripadvisor.com.br/Hotel_Review-g1598550-d10461949-Reviews-Hotel_Alzira_Imperial-Sao_Lourenco_State_of_Minas_Gerais.html',
    ariaLabel: 'Veja nossas avaliações no Tripadvisor'
  },
];

const SocialIcon = ({ id, Icon, name, link, ariaLabel, isScrolled }) => {
  return (
    <a
      href={link}
      className={`social-icon ${isScrolled ? 'scrolled' : ''} social-icon-${id}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      data-tooltip={name}
    >
      <Icon className="social-icon-image" />
    </a>
  );
};

SocialIcon.propTypes = {
  id: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  isScrolled: PropTypes.bool.isRequired
};

const FloatingSocialIcons = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isHomePage = location.pathname === '/';
    if (!isHomePage) {
      setIsScrolled(true);
      return;
    }
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location]);

  return (
    <div className="floating-icons" aria-label="Redes sociais">
      <div className="icons-container">
        {SOCIAL_ICONS.map((social) => (
          <SocialIcon
            key={social.id}
            id={social.id}
            Icon={social.Icon}
            name={social.name}
            link={social.link}
            ariaLabel={social.ariaLabel}
            isScrolled={isScrolled}
          />
        ))}
      </div>
    </div>
  );
};

export default FloatingSocialIcons;